import React, { useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { 
  FaCalendarAlt, FaPlus, FaEye, FaClock, FaCheckCircle,
  FaExclamationTriangle, FaTimes, FaSave, FaBan,
  FaUsers, FaDollarSign, FaHeart, FaPhone
} from 'react-icons/fa';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import '../../../../assets/css/customer/dashboard/MyEvents.css';
import CustomerLayout from '../../../../layouts/customer/CustomerLayout';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';
import Swal from 'sweetalert2';

const MAX_YEARS_AHEAD = 5;

const getTodayString = () => {
  const d = new Date();
  return d.toISOString().split('T')[0];
};

const getMaxDateString = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() + MAX_YEARS_AHEAD);
  return d.toISOString().split('T')[0];
};

const MyEvents = () => {

  const { baseUrl, loggedInCustomer, regexChecker } = useContext(AppContext);

  const [BrideName,  setBrideName]  = useState('');
  const [GroomName,  setGroomName]  = useState('');
  const [EventName,  setEventName]  = useState('');
  const [EventType,  setEventType]  = useState('');
  const [EventDate,  setEventDate]  = useState('');
  const [EventTime,  setEventTime]  = useState('');
  const [GuestCount, setGuestCount] = useState('');
  const [Budget,     setBudget]     = useState('');
  const [Notes,      setNotes]      = useState('');

  const [eventErrors, setEventErrors] = useState({
    brideName: '',
    groomName: '',
    eventName: '',
    eventType: '',
    eventDate: '',
    guestCount: '',
    budget: ''
  });

  const [events,       setEvents]       = useState([]);
  const [isLoading,    setIsLoading]    = useState(false);
  const [sgcShowAdd,   setSgcShowAdd]   = useState(false);
  const [sgcShowEdit,  setSgcShowEdit]  = useState(false);
  const [sgcShowView,  setSgcShowView]  = useState(false);
  const [sgcEditData,  setSgcEditData]  = useState({});
  const [sgcViewData,  setSgcViewData]  = useState({});

  const viewAllEvents = () => {
    const customerforid = JSON.parse(localStorage.getItem("loggedInCustomer"));
    const formData = new FormData();
    formData.append("wecustomer_id", customerforid.id);

    axios
      .post(`${baseUrl}/customer/events/viewAllEvents`, formData)
      .then((res) => setEvents(res.data))
      .catch((err) => console.log(err));
  };

  const resetEventErrors = () => {
    setEventErrors({
      brideName: '',
      groomName: '',
      eventName: '',
      eventType: '',
      eventDate: '',
      guestCount: '',
      budget: ''
    });
  };

  const validateEventDate = (value) => {
    if (!value) return 'Event Date is required';
    const selected = new Date(value);
    if (isNaN(selected.getTime())) return 'Please select a valid date';
    const todayStr = getTodayString();
    const maxStr = getMaxDateString();
    if (value < todayStr) return 'Event Date cannot be in the past';
    if (value > maxStr) return `Event Date seems invalid — please pick a date within ${MAX_YEARS_AHEAD} years`;
    return '';
  };

  const validateBudget = (value) => {
    if (!value) return '';
    const raw = String(value).replace(/,/g, '');
    if (isNaN(Number(raw)) || Number(raw) < 0) return 'Budget must be a valid number e.g. 500,000';
    return '';
  };

  const validateEventForm = () => {
    const rawBudget = String(Budget).replace(/,/g, '');
    const errors = {
      brideName:  BrideName  ? regexChecker('username', BrideName)  : '',
      groomName:  GroomName  ? regexChecker('username', GroomName)  : '',
      eventName:  EventName  ? regexChecker('eventName', EventName) : (!EventName.trim() ? 'Event Name is required' : ''),
      eventType:  EventType  ? '' : 'Event Type is required',
      eventDate:  validateEventDate(EventDate),
      guestCount: GuestCount ? regexChecker('guestCount', GuestCount) : '',
      budget:     validateBudget(rawBudget),
    };

    setEventErrors(errors);
    return Object.values(errors).some((err) => err);
  };

  const createEvent = () => {
    const hasErrors = validateEventForm();
    if (hasErrors) {
      Swal.fire({ icon: 'warning', title: 'Required Fields', text: 'Please fix the highlighted fields', confirmButtonColor: '#7fd3c1' });
      return;
    }

    const customerforid = JSON.parse(localStorage.getItem("loggedInCustomer"));
    setIsLoading(true);

    const rawBudget = String(Budget).replace(/,/g, '');

    const formData = new FormData();
    formData.append('wecustomer_id', customerforid.id);
    formData.append('brideName',  BrideName);
    formData.append('groomName',  GroomName);
    formData.append('eventName',  EventName);
    formData.append('eventType',  EventType);
    formData.append('eventDate',  EventDate);
    formData.append('eventTime',  EventTime);
    formData.append('guestCount', GuestCount);
    formData.append('budget',     rawBudget);
    formData.append('notes',      Notes);

    axios
      .post(`${baseUrl}/customer/events/createEvent`, formData)
      .then((res) => {
        Swal.fire({ title: 'Wow', text: 'Your Event has been created', confirmButtonText: 'Wow', icon: 'success' });
        viewAllEvents();
        setSgcShowAdd(false);
        setBrideName(''); setGroomName(''); setEventName('');
        setEventType(''); setEventDate(''); setEventTime('');
        setGuestCount(''); setBudget(''); setNotes('');
        resetEventErrors();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const updateEvent = () => {
    const hasErrors = validateEventForm();
    if (hasErrors) {
      Swal.fire({ icon: 'warning', title: 'Required Fields', text: 'Please fix the highlighted fields', confirmButtonColor: '#7fd3c1' });
      return;
    }

    setIsLoading(true);
    const customerforid = JSON.parse(localStorage.getItem("loggedInCustomer"));
    const rawBudget = String(Budget).replace(/,/g, '');

    const formData = new FormData();
    formData.append('id',            sgcEditData.id);
    formData.append('wecustomer_id', customerforid.id);
    formData.append('brideName',  BrideName);
    formData.append('groomName',  GroomName);
    formData.append('eventName',  EventName);
    formData.append('eventType',  EventType);
    formData.append('eventDate',  EventDate);
    formData.append('eventTime',  EventTime);
    formData.append('guestCount', GuestCount);
    formData.append('budget',     rawBudget);
    formData.append('notes',      Notes);

    axios
      .post(`${baseUrl}/customer/events/updateEvent`, formData)
      .then(() => {
        viewAllEvents();
        setSgcShowEdit(false);
        setBrideName(''); setGroomName(''); setEventName('');
        setEventType(''); setEventDate(''); setEventTime('');
        setGuestCount(''); setBudget(''); setNotes('');
        resetEventErrors();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const deleteEvent = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This event will be deleted permanently!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${baseUrl}/customer/events/deleteEvent/${id}`)
          .then(() => {
            viewAllEvents();
            Swal.fire('Deleted!', 'Event has been deleted.', 'success');
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const sgcOpenAdd = () => {
    resetEventErrors();
    setSgcShowAdd(true);
  };

  const sgcOpenEdit = (event) => {
    setSgcEditData(event);
    setBrideName(event.brideName);
    setGroomName(event.groomName);
    setEventName(event.eventName);
    setEventType(event.eventType);
    setEventDate(event.eventDate);
    setEventTime(event.eventTime);
    setGuestCount(event.guestCount);
    // Edit mein budget comma format mein dikhao
    const formatted = event.budget
      ? Number(String(event.budget).replace(/,/g, '')).toLocaleString('en-PK')
      : '';
    setBudget(formatted);
    setNotes(event.notes);
    resetEventErrors();
    setSgcShowEdit(true);
  };

  const sgcOpenView = (event) => {
    setSgcViewData(event);
    setSgcShowView(true);
  };

  const getStatusBadge = (statusType) => {
    const badges = {
      upcoming:  { icon: <FaClock />,              class: 'mye-badge-upcoming'  },
      completed: { icon: <FaCheckCircle />,         class: 'mye-badge-completed' },
      pending:   { icon: <FaExclamationTriangle />, class: 'mye-badge-pending'   }
    };
    return badges[statusType] || badges.upcoming;
  };

  const stats = {
    total:     events.length,
    upcoming:  events.filter(e => e.statusType === 'upcoming').length,
    completed: events.filter(e => e.statusType === 'completed').length,
    pending:   events.filter(e => e.statusType === 'pending').length
  };

  useEffect(() => {
    console.log("logged in customer from the events page", loggedInCustomer);
    viewAllEvents();
  }, []);

  const renderEventFormFields = () => (
    <Row>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Bride Name</label>
          <input
            className={`mye-modal-form-input ${eventErrors.brideName ? 'input-error' : ''}`}
            type="text"
            placeholder="e.g. Sara"
            value={BrideName}
            onChange={(e) => {
              setBrideName(e.target.value);
              setEventErrors({ ...eventErrors, brideName: regexChecker('username', e.target.value) });
            }}
          />
          {eventErrors.brideName && <p style={{ color: 'red', fontSize: '13px' }}>{eventErrors.brideName}</p>}
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Groom Name</label>
          <input
            className={`mye-modal-form-input ${eventErrors.groomName ? 'input-error' : ''}`}
            type="text"
            placeholder="e.g. Ahmed"
            value={GroomName}
            onChange={(e) => {
              setGroomName(e.target.value);
              setEventErrors({ ...eventErrors, groomName: regexChecker('username', e.target.value) });
            }}
          />
          {eventErrors.groomName && <p style={{ color: 'red', fontSize: '13px' }}>{eventErrors.groomName}</p>}
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Event Name *</label>
          <input
            className={`mye-modal-form-input ${eventErrors.eventName ? 'input-error' : ''}`}
            type="text"
            placeholder="e.g. Wedding Ceremony"
            value={EventName}
            onChange={(e) => {
              setEventName(e.target.value);
              setEventErrors({
                ...eventErrors,
                eventName: e.target.value.trim() ? regexChecker('eventName', e.target.value) : 'Event Name is required'
              });
            }}
          />
          {eventErrors.eventName && <p style={{ color: 'red', fontSize: '13px' }}>{eventErrors.eventName}</p>}
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Event Type *</label>
          <select
            className={`mye-modal-form-input ${eventErrors.eventType ? 'input-error' : ''}`}
            value={EventType}
            onChange={(e) => {
              setEventType(e.target.value);
              setEventErrors({ ...eventErrors, eventType: e.target.value ? '' : 'Event Type is required' });
            }}
          >
            <option value="">Select Type</option>
            <option>Wedding</option>
            <option>Mehndi</option>
            <option>Nikah</option>
            <option>Engagement</option>
            <option>Walima</option>
            <option>Birthday</option>
            <option>Anniversary</option>
          </select>
          {eventErrors.eventType && <p style={{ color: 'red', fontSize: '13px' }}>{eventErrors.eventType}</p>}
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Event Date *</label>
          <input
            className={`mye-modal-form-input ${eventErrors.eventDate ? 'input-error' : ''}`}
            type="date"
            min={getTodayString()}
            max={getMaxDateString()}
            value={EventDate}
            onChange={(e) => {
              setEventDate(e.target.value);
              setEventErrors({ ...eventErrors, eventDate: validateEventDate(e.target.value) });
            }}
          />
          {eventErrors.eventDate && <p style={{ color: 'red', fontSize: '13px' }}>{eventErrors.eventDate}</p>}
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Event Time</label>
          <select className="mye-modal-form-input" value={EventTime} onChange={(e) => setEventTime(e.target.value)}>
            <option value="">Select Time</option>
            <option value="Morning">🌅 Morning</option>
            <option value="Evening">🌙 Evening</option>
          </select>
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Guest Count</label>
          <input
            className={`mye-modal-form-input ${eventErrors.guestCount ? 'input-error' : ''}`}
            type="number"
            placeholder="Expected guests"
            value={GuestCount}
            onChange={(e) => {
              setGuestCount(e.target.value);
              setEventErrors({ ...eventErrors, guestCount: regexChecker('guestCount', e.target.value) });
            }}
          />
          {eventErrors.guestCount && <p style={{ color: 'red', fontSize: '13px' }}>{eventErrors.guestCount}</p>}
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Budget</label>
          <input
            className={`mye-modal-form-input ${eventErrors.budget ? 'input-error' : ''}`}
            type="text"
            placeholder="e.g. 500,000"
            value={Budget}
            onChange={(e) => {
              const raw = e.target.value.replace(/,/g, '');
              if (raw === '' || /^\d+$/.test(raw)) {
                const formatted = raw ? Number(raw).toLocaleString('en-PK') : '';
                setBudget(formatted);
                setEventErrors({ ...eventErrors, budget: validateBudget(raw) });
              }
            }}
          />
          {eventErrors.budget && <p style={{ color: 'red', fontSize: '13px' }}>{eventErrors.budget}</p>}
        </div>
      </Col>
      <Col xs={12}>
        <div className="mye-modal-form-group">
          <label className="mye-modal-form-label">Notes</label>
          <textarea className="mye-modal-form-input" rows={3} placeholder="Any special requirements..."
            value={Notes} onChange={(e) => setNotes(e.target.value)} />
        </div>
      </Col>
    </Row>
  );

  return (
    <CustomerLayout>
      <div className="mye-my-events-page">
        <Container fluid className="mye-container">

          <div className="mye-page-header">
            <div className="mye-header-content">
              <h1 className="mye-page-title">
                <FaCalendarAlt className="mye-title-icon" /> My Events
              </h1>
              <p className="mye-page-subtitle">View &amp; manage your wedding events</p>
            </div>
            <Button className="mye-btn-create" onClick={sgcOpenAdd}>
              <FaPlus className="mye-btn-icon" /> Create New Event
            </Button>
          </div>

          <Card className="mye-summary-card">
            <Card.Header className="mye-card-header">
              <h3 className="mye-section-title">Event Summary</h3>
            </Card.Header>
            <Card.Body className="mye-card-body">
              <Row className="mye-stats-row">
                <Col lg={3} md={6} xs={6} className="mye-stat-col">
                  <div className="mye-stat-item mye-stat-total">
                    <div className="mye-stat-value">{stats.total}</div>
                    <div className="mye-stat-label">Total Events</div>
                  </div>
                </Col>
                <Col lg={3} md={6} xs={6} className="mye-stat-col">
                  <div className="mye-stat-item mye-stat-upcoming">
                    <div className="mye-stat-value">{stats.upcoming}</div>
                    <div className="mye-stat-label">Upcoming</div>
                  </div>
                </Col>
                <Col lg={3} md={6} xs={6} className="mye-stat-col">
                  <div className="mye-stat-item mye-stat-completed">
                    <div className="mye-stat-value">{stats.completed}</div>
                    <div className="mye-stat-label">Completed</div>
                  </div>
                </Col>
                <Col lg={3} md={6} xs={6} className="mye-stat-col">
                  <div className="mye-stat-item mye-stat-pending">
                    <div className="mye-stat-value">{stats.pending}</div>
                    <div className="mye-stat-label">Pending</div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <div className="mye-events-section">
            <h2 className="mye-list-title">My Events List</h2>

            {events.length === 0 ? (
              <Card className="mye-no-events-card">
                <Card.Body className="mye-no-events-body">
                  <FaCalendarAlt className="mye-no-events-icon" />
                  <p className="mye-no-events-text">No events created yet</p>
                  <Button className="mye-btn-create-alt" onClick={sgcOpenAdd}>
                    <FaPlus className="mye-btn-icon" /> Create Your First Event
                  </Button>
                </Card.Body>
              </Card>
            ) : (
              <Row className="mye-events-list">
                {events.map((event) => {
                  const badgeInfo = getStatusBadge(event.statusType);
                  return (
                    <Col key={event.id} lg={12} className="mye-event-col">
                      <Card className="mye-event-card">
                        <Card.Body className="mye-event-body">
                          <div className="mye-event-header">
                            <div className="mye-event-main">
                              <div className="mye-event-emoji">{event.icon || '📅'}</div>
                              <div className="mye-event-title-section">
                                <h3 className="mye-event-name">{event.eventName}</h3>
                                {(event.brideName || event.groomName) && (
                                  <p style={{ fontSize:'0.95rem', color:'#7fd3c1', fontWeight:600, margin:'4px 0 8px', display:'flex', alignItems:'center', gap:6 }}>
                                    <FaHeart style={{ fontSize:'0.85rem' }} />
                                    {event.brideName} &amp; {event.groomName}
                                  </p>
                                )}
                                <Badge className={`mye-status-badge ${badgeInfo.class}`}>
                                  {badgeInfo.icon} {event.status}
                                </Badge>
                              </div>
                            </div>
                          </div>
                          <div className="mye-event-details">
                            <div className="mye-detail-item">
                              <span className="mye-detail-label"><FaCalendarAlt className="mye-detail-icon" /> Type:</span>
                              <span className="mye-detail-value">{event.eventType}</span>
                            </div>
                            <div className="mye-detail-item">
                              <span className="mye-detail-label"><FaClock className="mye-detail-icon" /> Date:</span>
                              <span className="mye-detail-value">{event.eventDate}</span>
                            </div>
                            <div className="mye-detail-item">
                              <span className="mye-detail-label"><FaUsers className="mye-detail-icon" /> Guests:</span>
                              <span className="mye-detail-value">{event.guestCount}</span>
                            </div>
                            <div className="mye-detail-item">
                              <span className="mye-detail-label"><FaDollarSign className="mye-detail-icon" /> Budget:</span>
                              <span className="mye-detail-value">{event.budget ? Number(String(event.budget).replace(/,/g, '')).toLocaleString('en-PK') : '—'}</span>
                            </div>
                          </div>
                          <div className="mye-event-actions">
                            <Button className="mye-btn-action mye-btn-view" onClick={() => sgcOpenView(event)}>
                              <FaEye className="mye-action-icon" /> View Details
                            </Button>
                            <Button className="mye-btn-action mye-btn-invitations" onClick={() => sgcOpenEdit(event)}>
                              <FiEdit2 className="mye-action-icon" /> Edit
                            </Button>
                            <Button className="mye-btn-action mye-btn-pay" onClick={() => deleteEvent(event.id)}>
                              <FiTrash2 className="mye-action-icon" /> Delete
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            )}
          </div>

        </Container>
      </div>

      {/* ADD MODAL */}
      {sgcShowAdd && (
        <div className="mye-modal-overlay" onClick={() => setSgcShowAdd(false)}>
          <div className="mye-modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="mye-modal-header-custom">
              <h5 className="mye-modal-title-custom">Create New Event</h5>
              <button className="mye-modal-close-custom" onClick={() => setSgcShowAdd(false)}>×</button>
            </div>
            <div className="mye-modal-body-custom">
              {renderEventFormFields()}
            </div>
            <div className="mye-modal-footer-custom">
              <button className="mye-modal-cancel-btn" onClick={() => setSgcShowAdd(false)}>Cancel</button>
              <button className="mye-modal-save-btn" onClick={createEvent} disabled={isLoading}>
                {isLoading ? 'Creating...' : 'Create Event'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {sgcShowEdit && (
        <div className="mye-modal-overlay" onClick={() => setSgcShowEdit(false)}>
          <div className="mye-modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="mye-modal-header-custom">
              <h5 className="mye-modal-title-custom">Edit Event</h5>
              <button className="mye-modal-close-custom" onClick={() => setSgcShowEdit(false)}>×</button>
            </div>
            <div className="mye-modal-body-custom">
              {renderEventFormFields()}
            </div>
            <div className="mye-modal-footer-custom">
              <button className="mye-modal-cancel-btn" onClick={() => setSgcShowEdit(false)}>Cancel</button>
              <button className="mye-modal-save-btn" onClick={updateEvent} disabled={isLoading}>
                {isLoading ? 'Updating...' : 'Update Event'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* VIEW DETAILS MODAL */}
      {sgcShowView && (
        <div className="mye-modal-overlay" onClick={() => setSgcShowView(false)}>
          <div className="mye-modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="mye-modal-header-custom">
              <h5 className="mye-modal-title-custom">Event Details</h5>
              <button className="mye-modal-close-custom" onClick={() => setSgcShowView(false)}>×</button>
            </div>
            <div className="mye-modal-body-custom">
              <div className="mye-details-list">
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaHeart className="mye-details-icon" /> Bride</span>
                  <span className="mye-details-value">{sgcViewData.brideName}</span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaHeart className="mye-details-icon" /> Groom</span>
                  <span className="mye-details-value">{sgcViewData.groomName}</span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaCalendarAlt className="mye-details-icon" /> Event Name</span>
                  <span className="mye-details-value">{sgcViewData.eventName}</span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaCalendarAlt className="mye-details-icon" /> Type</span>
                  <span className="mye-details-value">{sgcViewData.eventType}</span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaClock className="mye-details-icon" /> Date</span>
                  <span className="mye-details-value">{sgcViewData.eventDate}</span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaClock className="mye-details-icon" /> Time</span>
                  <span className="mye-details-value">{sgcViewData.eventTime}</span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaUsers className="mye-details-icon" /> Guests</span>
                  <span className="mye-details-value">{sgcViewData.guestCount}</span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaDollarSign className="mye-details-icon" /> Budget</span>
                  <span className="mye-details-value">
                    {sgcViewData.budget ? Number(String(sgcViewData.budget).replace(/,/g, '')).toLocaleString('en-PK') : '—'}
                  </span>
                </div>
                <div className="mye-details-item">
                  <span className="mye-details-label"><FaCalendarAlt className="mye-details-icon" /> Notes</span>
                  <span className="mye-details-value">{sgcViewData.notes}</span>
                </div>
              </div>
            </div>
            <div className="mye-modal-footer-custom">
              <button className="mye-modal-cancel-btn" onClick={() => setSgcShowView(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

    </CustomerLayout>
  );
};

export default MyEvents;